import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "overlay", "form"];

  connect() {
    this._onKeydown = (event) => {
      if (event.key === "Escape") this.closeModal();
    };
  }

  openModal() {
    this.modalTarget.classList.add("is-open");
    this.overlayTarget.classList.add("is-open");
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", this._onKeydown);
  }

  closeModal() {
    this.modalTarget.classList.remove("is-open");
    this.overlayTarget.classList.remove("is-open");
    document.body.style.overflow = "";
    window.removeEventListener("keydown", this._onKeydown);
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) this.closeModal();
  }

  // 入力内容をクリア(モード(ラジオ)はクリア対象外。選択状態の見た目は :has(:checked) のCSSで自動更新される)
  clear() {
    this.formTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        input.checked = false;
      });
    this.formTarget
      .querySelectorAll("textarea")
      .forEach((textarea) => {
        textarea.value = "";
      });
  }

  disconnect() {
    window.removeEventListener("keydown", this._onKeydown);
  }
}
